module.exports = __webpack_public_path__ + "img/28.65f3f765.jpg";